module.exports = __webpack_public_path__ + "static/media/three_dot_icon.61557a4a.svg";